// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__3tBt-","header":"styles_header__3Do4b","article":"styles_article__25owR","narrow_container":"styles_narrow_container__3CUKG"};